export default "__VITE_ASSET__ChrtqMaR__"